import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';
import RADApplication from '@/Management/RADApplication';
import ResourceManager from '@/Management/ResourceManager';
import PrincipalHistorizationOverviewViewModel from '@/ViewModels/Controls/PrincipalHistorizationOverviewViewModel';
import { IOperationResultDTO } from "coreframetypings/dto";
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';

declare let moment: moment.MomentStatic;

export default class HistorizationPointUIListener extends UIListener {

    private historicizeCalled : boolean;

    constructor() {
        super();
    }

    public onPropertyValueUpdated(context: DetailViewContext, property: string): void {
        this.updateHistorizablePrincipals(context);
        this.updateHistoricizeButton(context);
    }

    public onDetailViewReady(context: DetailViewContext): void {
        this.updateGUI(context);
    }

    public onBeforeCallOperation(context, operation: string): boolean | JQueryDeferred<boolean> | JQueryPromise<boolean> {
        if (!this.isDetailViewContext(context) || operation !== 'HistoricizeDV') {
            return super.onBeforeCallOperation(context, operation);
        }

        // Kannn nicht in dem "then" ausgeführt werden, da "onDetailViewClosed" eher ausgeführt wird.
        this.historicizeCalled = true
        
        context.save()
            .then((result) => {
                if (!result) {
                    // Bei Misserfolg muss das Flag zurückgesetzt werden.
                    this.historicizeCalled = false;
                }
            });

        return false;
    }

    public onDetailViewClosed(context: DetailViewContext): void {
        if (this.historicizeCalled) {
            RADEnvironmentProxy.getInstance().callStaticOperationWithoutTransaction({
                    pdTypeName: 'RAD.RADFoundation.ProblemDomain.History.HistorizationPoint',
                    operationName: 'HistoricizeAsync',
                    operationParameters: [context.genericObject.pdoId],
                    contextParameters: {}
                })
                .then((operationResultDTO) => {
                    if (this.validateStatus(operationResultDTO, true, false)) {
                        const messageBoxViewModel = MessageBoxViewModel.createNoticeMessageBox(operationResultDTO.returnValue);
                        RADApplication.getInstance().showMessageBox(messageBoxViewModel);
                    }
                });
        }
    }

    public onAfterRefresh(context: DetailViewContext): void {
        this.updateGUI(context);
    }

    private updateGUI(context: DetailViewContext): void {
        if (!this.isDetailViewContext(context)) {
            return;
        }

        let processed = context.getUIFactory('SuccesfullyProcessed') as ControlFactory;
        let logItem = context.getUIFactory('Description') as ControlFactory;

        processed.isVisible(false);
        logItem.isRequired(true);

        if (RADApplication.getInstance().isSystemParamSetAndTrue('Historization.Global')) {
            (context.getUIFactory('PrincipalHistorizationOverviewXml') as ControlFactory).isVisible(false);
        }

        if (RADApplication.getInstance().isSystemParamSetAndTrue('Historization.AllModules')) {
            (context.getUIFactory('Modules') as ControlFactory).isVisible(false);
        }

        if (this.hasBeenHistorized(context)) {
            (context.getUIFactory('HistorizationDate') as ControlFactory).isEnabled(false);
            (context.getUIFactory('Modules') as ControlFactory).isEnabled(false);
        }

        this.updateHistorizablePrincipals(context);
        this.updateHistoricizeButton(context);
    }

    private hasBeenHistorized(context: DetailViewContext): boolean {
        return context.genericObject.getValue('SuccesfullyProcessed');
    }

    private updateHistorizablePrincipals(context: DetailViewContext): void {
        let value = context.genericObject.getValue('HistorizationDate');

        if (value == null) {
            return;
        }

        let endOfDay = moment(value).endOf('day');
        let factory = context.getUIFactory('PrincipalHistorizationOverviewXml') as ControlFactory;

        if (factory != null) {
            (factory.viewModel as PrincipalHistorizationOverviewViewModel).maxPrincipalCreatedDate(endOfDay);
        }
    }

    private updateHistoricizeButton(context: DetailViewContext): void {
        var element = context.toolBar.getElementByErgName('RAD.RADFOUNDATION.PROBLEMDOMAIN.HISTORY.HISTORIZATIONPOINT_HISTORICIZE_ERGNAME');
        var enabled = false;

        if (element == null) {
            return;
        }

        if (RADApplication.getInstance().isSystemParamSetAndTrue('Historization.Global')) {
            enabled = !this.hasBeenHistorized(context);
        } else {
            enabled = this.isPrincipalSelectedForHistorization(context);
        }

        element.isEnabled(enabled);
    }

    private isPrincipalSelectedForHistorization(context: DetailViewContext): boolean {
        var factory = context.getUIFactory('PrincipalHistorizationOverviewXml') as ControlFactory;

        if (factory == null) {
            return false;
        }

        return (factory.viewModel as PrincipalHistorizationOverviewViewModel).isAnyPrincipalSelected();
    }
}

ComponentManager.setUIListener('HistorizationPointUIListener', HistorizationPointUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.HistorizationPointListener', HistorizationPointUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');